module.exports = __webpack_public_path__ + "img/logo-vertical-minjus-2021.8e8dc081.png";